import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Home from "./pages/Home";
import ProjectsGrid from "./pages/ProjectsGrid";
import ChambreEcoute1 from "./pages/ChambreEcoute1";
import ChambreEcoute2 from "./pages/ChambreEcoute2";
import Phonemes2 from "./pages/Phonemes2";
import Phonemes1 from "./pages/Phonemes1";
import ChambreEcouteAnhydran from "./pages/ChambreEcouteAnhydran";
import LaboratoireSymbiotique from "./pages/LaboratoireSymbiotique";
import Apropos from "./pages/APropos";
import QuatrePortes from './pages/QuatrePortes';
import Phaino from './pages/Phaino';
import References from './pages/References';
import Pedagogie from './pages/Pedagogie';

function App() {
  return (
    <Router future={{
      v7_startTransition: true,
      v7_relativeSplatPath: true,
    }}>
      <Routes>
        {/* Routes principales */}
        <Route path="/" element={<Home />} />
        <Route path="/projets" element={<ProjectsGrid />} />
        
        {/* Projets individuels */}
        <Route path="/noise" element={<div>Page Noise - rumeurs et anomalies (à implémenter)</div>} />
        <Route path="/siloportem" element={<div>Page SILOPORTEM - Weaving the Heart Machine (à implémenter)</div>} />
        <Route path="/anhydran" element={<div>Page An·hydra·n (à implémenter)</div>} />
        <Route path="/phonemes2" element={<Phonemes2 />} />
        <Route path="/phonemes1" element={<Phonemes1 />} />
        <Route path="/transmutation" element={<div>Page Transmutation (à implémenter)</div>} />
        <Route path="/flots" element={<div>Page Flots (à implémenter)</div>} />
        <Route path="/transcendance" element={<div>Page Transcendance (à implémenter)</div>} />
        <Route path="/tina" element={<div>Page T.I.N.A (à implémenter)</div>} />
        <Route path="/eveil" element={<div>Page Éveil (à implémenter)</div>} />
        <Route path="/phaino" element={<Phaino />} />
        
        {/* Recherche */}
        <Route path="/recherche" element={<div>Page Recherche (à implémenter)</div>} />
        <Route path="/atlas-recherche" element={<div>Page Atlas de recherche (à implémenter)</div>} />
        <Route path="/laboratoire-symbiotique" element={<LaboratoireSymbiotique />} />
        <Route path="/chambre-ecoute1" element={<ChambreEcoute1 />} />
        <Route path="/chambre-ecoute2" element={<ChambreEcoute2 />} />
        <Route path="/chambre-ecoute-anhydran" element={<ChambreEcouteAnhydran />} />
        
        {/* Pages principales */}
        <Route path="/Apropos" element={<Apropos />} />
        <Route path="/quatre-portes" element={<QuatrePortes />} />
        <Route path="/references" element={<References />} />
        <Route path="/pedagogie" element={<Pedagogie />} />
        
        {/* Routes de redirection ou anciennes */}
        <Route path="/anhydran" element={<ChambreEcouteAnhydran />} />
      </Routes>
    </Router>
  );
}

export default App;